/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* istanbul ignore file */
import { whakapapaToSVG, WhakapapaRecord } from "@plinknz/tah-website-elements";

import * as Survey from "survey-react";
import { format } from "date-fns";
import {
    InteractionPayload,
    LinkPayload,
    MemberPayload,
    RegisterPayload,
} from "../../config/forms/register/payload";
import { createSVG, SVGLine } from "../svg/svg";

interface TransformRegistrationFormDataProps {
    survey: Survey.SurveyModel;
    tupuna: string;
    tupunaBaseId: string;
}

function pruneEmptyWhakapapa(data: WhakapapaRecord) {
    const newRec: WhakapapaRecord = { name: data.name };

    if (data.mother.name) {
        newRec.mother = pruneEmptyWhakapapa(data.mother);
    }

    if (data.father.name) {
        newRec.father = pruneEmptyWhakapapa(data.father);
    }

    return newRec;
}

function getGender(gender: string): string {
    if (gender === "Tāne") {
        return "Male";
    }
    if (gender === "Wahine") {
        return "Female";
    }
    return "";
}

function generateSVG(survey: Survey.SurveyModel) {
    const { data } = survey;
    const { signed } = data;

    const lines: SVGLine[] = [];

    ["education", "details"].forEach((attribute) => {
        if (data[attribute]) {
            const label = attribute[0].toUpperCase() + attribute.slice(1);
            lines.push({ label, text: data[attribute] });
        }
    });

    lines.push({ src: signed });

    const registrationSvg = createSVG({
        lines,
        heading: "Member Registration",
    });

    return registrationSvg;
}

export function transformRegistrationFormData({
    survey,
    tupuna,
    tupunaBaseId,
}: TransformRegistrationFormDataProps): RegisterPayload {
    const surveyData = survey.data;
    const gender = getGender(surveyData.gender);
    const dob = format(new Date(surveyData.dob), "yyyyMMdd");

    const data: MemberPayload = {
        title: surveyData.title,
        firstName: surveyData.firstName,
        middleNames: surveyData.middleNames,
        surname: surveyData.surname,
        gender,
        cell: surveyData.cell,
        phone: surveyData.phone,
        email: surveyData.email,
        occupation: surveyData.occupation,
        line1: surveyData.addressfinder.address_line_1 || "",
        line2: surveyData.addressfinder.address_line_2 || "",
        suburb: surveyData.addressfinder.suburb || "",
        city: surveyData.addressfinder.city || "",
        postcode: surveyData.addressfinder.postcode || "",
        country: surveyData.addressfinder.country || "",
        dob,
        tupunaBaseId,
        tupuna,
    };

    const svg = generateSVG(survey);
    const interactions: InteractionPayload[] = [{ value: svg }];
    const links: LinkPayload[] = [];

    if (surveyData.signed) {
        links.push({
            type: "attachment",
            value: surveyData.signed,
        });
    }

    const name = `${data.firstName}${
        data.middleNames ? ` ${data.middleNames}` : ""
    } ${data.surname}`;
    const rawWhakapapa = { ...surveyData.whakapapa, name };
    const whakapapaData = pruneEmptyWhakapapa(rawWhakapapa);
    const whakapapaSvg = whakapapaToSVG(
        whakapapaData,
        "Registration Whakapapa"
    );

    interactions.push({ value: whakapapaSvg });

    return { data, interactions, links, recaptcha: null, tenant: "KUIA" };
}
